import React from 'react';
import { Modal, Typography } from 'antd';
import { MergedOrder } from '../../../../types/process/order';

const { Text, Paragraph } = Typography;

interface CancelReasonViewModalProps {
  visible: boolean;
  order: MergedOrder | null;
  onCancel: () => void;
}

const CancelReasonViewModal: React.FC<CancelReasonViewModalProps> = ({ visible, order, onCancel }) => {
  if (!order) return null;

  const isInterrupt = !!order.audit?.interruptReason;

  return (
    <Modal
      title={isInterrupt ? "查看中断原因" : "查看取消原因"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <div style={{ padding: '10px 0' }}>
        {isInterrupt ? (
          <Paragraph>
            <Text strong>中断原因：</Text> <Text>{order.audit?.interruptReason}</Text>
          </Paragraph>
        ) : (
          <>
            <Paragraph>
              <Text strong>取消类型：</Text> <Text>{order.order.cancelType || '未知'}</Text>
            </Paragraph>
            <Paragraph>
              <Text strong>取消分类：</Text> <Text>{order.order.cancelCategory || '未知'}</Text>
            </Paragraph>
            <Paragraph>
              <Text strong>取消原因：</Text> <Text>{order.order.cancelReason || '暂无详细原因'}</Text>
            </Paragraph>
          </>
        )}
      </div>
    </Modal>
  );
};

export default CancelReasonViewModal;
